import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/BaseElementsCSS/BaseElementsDesktop.css';
import HomeButton from './HomeButton';


function TopBarTutorial() {
    return (
        <div className="baseElementsTopBar" style={{maxHeight: '100%'}}>
            <HomeButton className='baseElementsTopBarIconCol'></HomeButton>
        </div>
    );
}


export default TopBarTutorial;